import { formatDistanceToNow } from 'date-fns';
import { de, enUS } from 'date-fns/locale';
import { ILanguage } from 'my-poppies-b2b-types';
import { useEffect, useState } from 'react';

interface ISinceProps {
  prefix?: string;
  suffix?: string;
  timestamp: number; // Unix timestamp in milliseconds
  locale: ILanguage;
}

const localeMap = {
  en: enUS,
  de: de,
};

export const Since: React.FC<ISinceProps> = ({ prefix = '', suffix = '', timestamp, locale }) => {
  const [sinceString, setSinceString] = useState('');

  useEffect(() => {
    const update = () => {
      const distance = formatDistanceToNow(new Date(timestamp * 1000), {
        addSuffix: false,
        locale: localeMap[locale],
        includeSeconds: false, // hide seconds after 1 min automatically
      });
      setSinceString(distance);
    };

    update(); // initial call
    const interval = setInterval(update, 1000);

    return () => clearInterval(interval);
  }, [timestamp, locale]);

  return (
    <>
      {prefix}
      {sinceString
        .replace(/Tage/gi, 'Tagen')
        .replace(/Monate/gi, 'Monaten')
        .replace(/Jahre/gi, 'Jahren')}
      {suffix}
    </>
  );
};
